import { Injectable, DOCUMENT } from '@angular/core';

import { Inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DomainResolverService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  resolve(): string {
    const hostname = this.normalize(this.document.location.hostname);

    if (this.isLocal(hostname)) {
      const override = new URLSearchParams(this.document.location.search)
        .get('operatorDomain');
      if (override) {
        return this.normalize(override);
      }
    }

    return hostname;
  }

  isLocal(domain = this.normalize(this.document.location.hostname)): boolean {
    return domain === 'localhost' || domain === '127.0.0.1' || domain === '::1';
  }

  normalize(value: string): string {
    const trimmed = (value || '').trim().toLowerCase();
    const withoutScheme = trimmed.replace(/^https?:\/\//, '').split('/')[0];
    const bracketedIpv6 = withoutScheme.match(/^\[([0-9a-f:]+)\](?::\d+)?$/i);
    const withoutPort = bracketedIpv6
      ? bracketedIpv6[1]
      : withoutScheme.includes('::')
        ? withoutScheme
        : withoutScheme.replace(/:\d+$/, '');
    return withoutPort.replace(/^www\./, '');
  }
}
